import React from 'react'
import { AiOutlineFullscreenExit } from "react-icons/ai"
import useAppContext from '../../hook/useAppContext'
import './modal.css'

const Modal = () => {

      const {obj, modal, setModal} = useAppContext()

      //if(!modal) return 

      const closeModal = () => {
            setModal(!modal)
      }

      return (
            <div className={modal ? "modal_content active flex" : "modal_content flex"}>
                  <div className="modal_inner">
                        <img src={obj.url} alt={obj.title} />
                  </div>
                  <button className="close_modal flex" onClick={() => closeModal()}><AiOutlineFullscreenExit /></button>
            </div>
      )
}

export default Modal
